import React from 'react';
import { getLangOptions, useLanguage } from './LanguageContext';

import './LanguageSelector.css';

export const LanguageSelector: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const { language, setLanguage } = useLanguage();

    const toggleDropdown = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen(prev => !prev);
    };

    const handleSelect = (lang: string, e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen(false);
        setLanguage(lang);
    };

    const options = getLangOptions();
    const currentLang = options.find(opt => opt.code === language);

    return (
        <div className="dim-nav-lang-dropdown" onClick={toggleDropdown}>
            <span className="dim-nav-lang-current">
            {/*currentLang && (
                <img
                    src={currentLang.flag}
                    alt={currentLang.code}
                    width={20}
                    style={{ marginRight: 8, verticalAlign: 'middle' }}
                />
            )*/}
            {currentLang?.label} ▼
            </span>
        {open && (
            <div className="dim-nav-lang-menu">
                {options.map(({ code, label, flag }) => (
                    <div key={code}
                        className={`dim-nav-lang-option ${language === code ? 'active-lang' : ''}`}
                        onClick={(e) => handleSelect(code, e)} >

                        {/*<img src={flag}
                            alt={code}
                            width={20}
                            style={{ marginRight: 8, verticalAlign: 'middle' }}
                        />*/}
                    {label}
                    </div>
                ))}
            </div>
        )}
    </div>
  );
};


